import { inject, Injectable } from '@angular/core';
import { SessionStorageService } from '../../../../core/services/session-storage/session-storage.service';
import { environment } from '../../../../../environments/environment';
import axios, { AxiosRequestConfig, AxiosError } from 'axios';

@Injectable({
  providedIn: 'root'
})
export class DashboardGetAdvisorsDataByBranchService {

  private sessionStorageService = inject(SessionStorageService);

  constructor() { }

  async getDashboardBranchwiseAdvisors(branchName: string) {
    const API_URL: string = environment.baseUrl + environment.apis.dashboardBranchwiseadvisors;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        "branchname": branchName
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

}
